import { Component, OnInit } from '@angular/core';
import { FlashMessagesService } from 'angular2-flash-messages/module';
import { DialogComponent, DialogService } from 'ng2-bootstrap-modal';
import { EconomicGroupService } from '../../service/economic-group.service';

export interface ConfirmModel {
	title: string;
	groupType;
	economicGroup;
	groupMembers;
	userID;
}

@Component({
	selector: 'app-economic-group-insert-user',
	templateUrl: './economic-group-insert-user.component.html',
	styleUrls: ['./economic-group-insert-user.component.scss'],
	providers: [EconomicGroupService],
})
export class EconomicGroupInsertUserComponent
	extends DialogComponent<ConfirmModel, boolean>
	implements ConfirmModel, OnInit
{
	public cpfMask = [
		/\d/,
		/\d/,
		/\d/,
		'.',
		/\d/,
		/\d/,
		/\d/,
		'.',
		/\d/,
		/\d/,
		/\d/,
		'-',
		/\d/,
		/\d/,
	];
	public cnpjMask = [
		/\d/,
		/\d/,
		'.',
		/\d/,
		/\d/,
		/\d/,
		'.',
		/\d/,
		/\d/,
		/\d/,
		'/',
		/\d/,
		/\d/,
		/\d/,
		/\d/,
		'-',
		/\d/,
		/\d/,
	];

	title: string;
	groupType;
	economicGroup;
	groupMembers;
	userID;

	private newMemberList = [];
	private canInclude = false;
	private editMode = false;
	private errorMessage;

	private tempMember = {
		memberID: '',
		memberName: '',
		memberDoc: '',
		memberCode: '',
		memberCreditLimit: '',
		memberExposure: '',
		ExplodeGrupo: true,
		canRemove: true,
	};

	constructor(
		dialogService: DialogService,
		private economicGroupService: EconomicGroupService,
		private flashMessagesService: FlashMessagesService
	) {
		super(dialogService);
	}

	ngOnInit() {}

	getFinancialDetail(userCode) {
		this.economicGroupService.getFinancialDetail(userCode).subscribe(
			(result) => {
				if (result.Result) {
					this.tempMember.memberCreditLimit = result.Result.LC;
					this.tempMember.memberExposure = result.Result.Exposicao;
				}
			},
			(error) => {
				console.log(error);
			}
		);
	}

	cancel() {
		this.close();
	}

	mask(): any {
		return {
			mask: (value) => {
				value = value.replace(/[^\d]+/g, '');
				if (value.length < 12) return this.cpfMask;
				else return this.cnpjMask;
			},
		};
	}

	onSaveMembers() {
		var tempMemberList = [];
		this.newMemberList.forEach((member) => {
			tempMemberList.push({
				ContaClienteID: member.memberID,
				GrupoEconomicoID: this.economicGroup.GrupoId,
				ContaClienteIDAcesso: this.userID,
				ExplodeGrupo: member.ExplodeGrupo || false,
			});
		});

		this.economicGroupService.insertGroupMember(tempMemberList).subscribe(
			(result) => {
				if (result.Success) {
					this.flashMessagesService.show('Membros salvos com sucesso!', {
						cssClass: 'alert-success',
						timeout: 6000,
					});
					this.result = true;
					this.cancel();
				} else {
					this.errorMessage = result.Errors;
				}
			},
			(error) => {
				console.log(error);
			}
		);
	}

	deleteMember(i) {
		this.newMemberList.splice(i, 1);
	}

	addMember() {
		var memberTest = this.groupMembers.filter(
			(member) => member.ClienteId == this.tempMember.memberID
		);
		if (memberTest[0]) {
			this.canInclude = false;
			this.tempMember = {
				memberID: '',
				memberName: '',
				memberDoc: '',
				memberCode: '',
				memberCreditLimit: '',
				memberExposure: '',
				ExplodeGrupo: true,
				canRemove: true,
			};
		} else {
			var memberTest2 = this.newMemberList.filter(
				(member) => member.memberID == this.tempMember.memberID
			);
			if (memberTest2[0]) {
				this.canInclude = false;
				this.tempMember = {
					memberID: '',
					memberName: '',
					memberDoc: '',
					memberCode: '',
					memberCreditLimit: '',
					memberExposure: '',
					ExplodeGrupo: true,
					canRemove: true,
				};
			} else {
				this.newMemberList.push(this.tempMember);
				this.canInclude = false;
				this.tempMember = {
					memberID: '',
					memberName: '',
					memberDoc: '',
					memberCode: '',
					memberCreditLimit: '',
					memberExposure: '',
					ExplodeGrupo: true,
					canRemove: true,
				};
			}
			console.log(this.newMemberList.length);
		}
	}

	docChanged() {
		this.canInclude = false;
		this.tempMember.memberName = '';
		this.tempMember.memberCode = '';
		this.tempMember.memberCreditLimit = '';
		this.tempMember.memberExposure = '';

		if (this.tempMember.memberDoc.replace(/[^\d]+/g, '').length == 11) {
			this.editMode = !this.getAccountClientByDoc();
		}
		if (this.tempMember.memberDoc.replace(/[^\d]+/g, '').length == 14) {
			this.editMode = !this.getAccountClientByDoc();
		}
	}

	codChanged() {
		if (this.tempMember.memberCode.length == 10) {
			this.editMode = !this.getAccountClientByCod();
		}
	}

	codChangedEnterKey() {
		if (this.tempMember.memberCode.trim() != '') {
			this.editMode = !this.getAccountClientByCod();
		}
	}

	getAccountClientByCod() {
		this.economicGroupService
			.getAccountClientByCod(this.tempMember.memberCode)
			.subscribe(
				(result) => {
					console.log('After search', result);
					if (result.Result && result.Result.length > 0) {
						this.tempMember.memberID = result.Result[0].ID;
						this.tempMember.memberDoc = result.Result[0].Documento;
						this.tempMember.memberName = result.Result[0].Nome;
						this.tempMember.memberCode = result.Result[0].CodigoPrincipal;
						this.getFinancialDetail(this.tempMember.memberCode);
						this.tempMember.canRemove = true;
						this.canInclude = true;
						return true;
					} else {
						console.log('Didnt find!');

						this.canInclude = false;

						this.tempMember.memberID = '';
						this.tempMember.memberDoc = '';
						this.tempMember.memberName = '';
						this.tempMember.memberCode = '';
						this.tempMember.memberCreditLimit = '';
						this.tempMember.memberExposure = '';

						return false;
					}
				},
				(error) => {
					console.log(error);
				}
			);
		return true;
	}

	getAccountClientByDoc() {
		this.economicGroupService
			.getAccountClientByDoc(this.tempMember.memberDoc.replace(/[^\d]+/g, ''))
			.subscribe(
				(result) => {
					console.log('After search', result);
					if (result.Result[0]) {
						this.tempMember.memberID = result.Result[0].ID;
						this.tempMember.memberDoc = result.Result[0].Documento;
						this.tempMember.memberName = result.Result[0].Nome;
						this.tempMember.memberCode = result.Result[0].CodigoPrincipal;
						this.getFinancialDetail(this.tempMember.memberCode);
						this.tempMember.canRemove = true;
						this.canInclude = true;
						return true;
					} else {
						console.log('Didnt find!');
						return false;
					}
				},
				(error) => {
					console.log(error);
				}
			);
	}
}



// WEBPACK FOOTER //
// ./src/app/economic-group/component/economic-group-insert-user/economic-group-insert-user.component.ts